// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"loadingOverlay-t9KUg","wrapper":"wrapper-UE0jF"};